// Central site configuration - all outbound links, codes and copy live here.
// This is a static promo/landing site: no backend data is required.

export const SITE = {
  name: "flounder king",
  tagline: "Rule the reef, claim your rewards",
  code: "MOM",
  partner: {
    name: "BetBolt",
    displayDomain: "betbolt.com",
    url: "https://betbolt.com/?r=MOM",
    logo: "/img/betbolt.webp",
  },
  socials: {
    x: {
      label: "X / Twitter",
      handle: "@flounderking69",
      note: "Stay in touch",
      url: "https://x.com/flounderking69",
      cta: "Follow",
    },
    kick: {
      label: "Kick",
      handle: "flounderking",
      note: "Watch the streams",
      url: "https://kick.com/flounderking",
      cta: "Watch",
    },
    discord: {
      label: "Discord",
      handle: "Flounder Court",
      note: "Join the community",
      url: "https://discord.com/invite/UHGHwVyXJf",
      cta: "Join",
    },
  },
  kickChannel: "flounderking",
  kickPlayerUrl: "https://player.kick.com/flounderking?muted=true",
};

export const STEPS = [
  {
    num: "01",
    title: "Dive in",
    text: "Create your account on BetBolt in under a minute.",
  },
  {
    num: "02",
    title: 'Use code "MOM"',
    text: "Redeem the code in the rewards section to link your account.",
  },
  {
    num: "03",
    title: "Wager & climb",
    text: "Every wager pushes you up the reef. Higher depth, bigger loot.",
  },
  {
    num: "04",
    title: "Claim rewards",
    text: "Monthly payouts land straight in your balance. No hoops.",
  },
];

export const BONUS_PERKS = [
  "Instant rakeback on every wager",
  "VIP rewards & exclusive bonus drops",
  "Entry into the monthly FLOUNDER leaderboard",
];

export const CLAIM_STEPS = [
  "Register on betbolt.com",
  'Open Rewards and redeem the code "MOM"',
  "Enjoy instant rakeback, VIP perks & leaderboard entry",
];
